export const CM_PAGE_LOAD_REQUEST = 'CM_PAGE_LOAD_REQUEST';
export const CM_PAGE_LOAD_SUCCESS = 'CM_PAGE_LOAD_SUCCESS';
export const CM_PAGE_LOAD_ERROR = 'CM_PAGE_LOAD_ERROR';
export const CM_LOAD_ERROR_PAGE = 'CM_LOAD_ERROR_PAGE';
export const CM_FALLBACK_TO_IRIS = 'CM_FALLBACK_TO_IRIS';
